/* eslint-disable no-unused-vars */
import ImageUploading from 'react-images-uploading';
import Resizer from 'react-image-file-resizer';
import { useSelector } from 'react-redux';
import { MEDIATYPES } from 'constants';
import { ImageUploadHandler } from './ImageUploadHandler';
import { useSignal } from '@preact/signals-react';

export const ImgUploader = ({
  resolutionWidth,
  resolutionHeight,
  selectedImg$,
  uploadAction,
  currentSelectedSize$,
  uploadResult,
}) => {
  const pba_id = useSelector((state) => state.creatives.creativeAndTrackingData.pba_id);
  const app_package = useSelector((state) => state.creatives.creativeAndTrackingData.app_package);

  const onChange = (imageList) => {
    if (imageList.length > 0) {
      const dataURL = imageList[imageList.length - 1]['data_url'];
      const img = new Image();
      img.src = dataURL;
      img.onload = () => {
        console.log(`width: ${img.width}, height: ${img.height}`);
      };
      uploadAction({
        imageType: currentSelectedSize$.value.imageType.toString(),
        pba_id: pba_id,
        package_id: app_package,
        file: dataURL,
      });
    }
  };
  return (
    <div className='' style={{ flexGrow: '1' }}>
      <ImageUploading
        value={selectedImg$.value}
        onChange={onChange}
        dataURLKey='data_url'
        acceptType={['png', 'jpg', 'jpeg', 'gif']}
        resolutionWidth={resolutionWidth}
        resolutionHeight={resolutionHeight}
        resolutionType='absolute'
      >
        {({ onImageUpload, isDragging, dragProps, errors }) => {
          return (
            <ImageUploadHandler
              isDragging={isDragging}
              dragProps={dragProps}
              errors={errors}
              onImageUpload={onImageUpload}
              uploadResult={uploadResult}
              resolutionWidth={resolutionWidth}
              resolutionHeight={resolutionHeight}
            />
          );
        }}
      </ImageUploading>
    </div>
  );
};
